import { Section } from '@policygenius/dif-ts-types';

const schema: Section = {
  nodeType: 'SECTION',
  urn: 'urn:pg:interview:section:continue-online-criminal-history',
  content: '',
  rules: { operation: '=', field: 'children.all.valid', value: true },
  presentationRules: {
    section_criminal_followup: {
      field: 'question_insured_risk_activity_criminal_conviction.value',

      value: true,
      operation: '=',
    },
  },
  children: [
    {
      nodeType: 'QUESTION',
      questionType: 'BOOLEAN',
      urn: 'urn:pg:interview:question:insured-risk-activity-criminal-conviction',
      dataPoint: {
        urn: 'urn:pg:data-point:insured-risk-activity-criminal-conviction',
        dataType: 'boolean',
      },
      content:
        'Have you ever been arrested for, imprisoned for, convicted of, or pled guilty or no contest to, a felony or misdemeanor or infraction other than a traffic violation? Or do you have any such charge pending, or are you currently incarcerated or on parole or probation?',

      rules: { field: 'value.present', value: true, operation: '=' },
    },
    {
      nodeType: 'SECTION',
      urn: 'urn:pg:interview:section:criminal-followup',
      content: '',
      rules: { operation: '=', field: 'children.all.valid', value: true },
      children: [
        {
          nodeType: 'QUESTION',
          questionType: 'BOOLEAN',
          urn: 'urn:pg:interview:question:insured-risk-activity-criminal-conviction-recently-discharged',
          dataPoint: {
            urn: 'urn:pg:data-point:insured-risk-activity-criminal-conviction-recently-discharged',
            dataType: 'boolean',
          },
          content:
            'Are you currently on probation/parole, or were you discharged or released within the last 12 months?',
          rules: { field: 'value.present', value: true, operation: '=' },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'DATE',
          urn: 'urn:pg:interview:question:insured-risk-activity-criminal-conviction-date',
          dataPoint: {
            urn: 'urn:pg:data-point:insured-risk-activity-criminal-conviction-date',
            dataType: 'date',
          },
          content: 'Date you were charged',
          rules: { field: 'value.present', value: true, operation: '=' },
        },
        {
          nodeType: 'QUESTION',
          questionType: 'TEXT',
          urn: 'urn:pg:interview:question:insured-risk-activity-criminal-conviction-description',
          dataPoint: {
            urn: 'urn:pg:data-point:insured-risk-activity-criminal-conviction-description',
            dataType: 'text',
          },
          content: 'Charge',
          rules: { field: 'value.present', value: true, operation: '=' },
        },
      ],
    },
  ],
};

export default schema;
